import validate from '@ott/utility-form-validate';
import rules from '@ott/utility-form-validate-rules';

// import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
//
// const MAX_DURATION = 15;
// const MIN_DURATION = 2;

const fieldsValidations = {
  destination: [
    {
      msg: 'Это поле необходимо заполнить',
      validate: rules.isRequired,
    },
  ],
  departure: [
    {
      msg: 'Это поле необходимо заполнить',
      validate: rules.isRequired,
    },
  ],
  adults: [
    {
      msg: 'Должен быть хотя бы один взрослый',
      validate: (adults) => adults > 0,
    },
  ],
  dates: [
    {
      msg: 'Не выбрана дата начала путешествия',
      validate: ({ startDate } = {}) => rules.isRequired(startDate),
    },
    // {
    //   msg: 'Не выбрана дата окончания путешествия',
    //   validate: ({ endDate }) => rules.isRequired(endDate),
    // },
    // {
    //   msg: `Тур может быть от ${MIN_DURATION} до ${MAX_DURATION} ночей`,
    //   validate: ({ startDate, endDate }) => {
    //     const duration = differenceInCalendarDays(new Date(endDate), new Date(startDate));
    //     return MIN_DURATION <= duration && duration <= MAX_DURATION;
    //   },
    // },
  ],
};

const composeValidations = (fields) =>
  fields.reduce((validations, field) => {
    // eslint-disable-next-line no-param-reassign
    validations[field] = fieldsValidations[field];

    return validations;
  }, {});

export default (fields) => validate(composeValidations(fields));
